module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/online-database-2.b2c16b5b.svg";